import { remove } from 'ramda'

import { SchemaCondition } from '@/__generated/es-api'

// The form edits condition groups; the API wraps them in an outer OR.
export const toConditionsFormValue = (conditions?: SchemaCondition[] | null): string =>
  JSON.stringify(remove(0, 1, conditions || (['or', ['and', ['', '', '']]] as SchemaCondition[])))

/**
 * @param conditions '[["and",["==","{{contact.firstName}}","John"]]]' => ['or', ['and', ['==', '{{contact.firstName}}', 'John']]]
 */
export const toConditions = (conditions: string): SchemaCondition[] => ['or', ...JSON.parse(conditions)]
